<template>
  <div
    class="column queue-select-root"
    @mouseenter="onFieldEnter"
    @mouseleave="fieldTooltip = false"
  >
    <q-select
      outlined
      dense
      v-model="selectedValue"
      map-options
      emit-value
      hide-dropdown-icon
      :options="filteredOptions"
      option-value="id"
      option-label="label"
      bg-color="white"
      :options-dense="true"
      class="col-auto queueSelect"
      :disable="disabled"
      popup-content-class="field-select-popup"
      @popup-show="measureOptions"
      @virtual-scroll="measureOptions"
    >
      <template #append>
        <div
          v-if="!loading"
          class="row items-center justify-center"
        >
          <ArrowDownIcon class="col" />
        </div>

        <q-spinner
          v-if="loading"
          color="primary"
          size="xs"
        />
      </template>

      <template #selected>
        <span class="ellipsis field-select-value">{{ selectedLabel }}</span>
      </template>

      <template #option="scope">
        <q-item
          v-bind="scope.itemProps"
          v-on="scope.itemEvents"
        >
          <q-item-section>
            <q-item-label
              class="ellipsis"
              :data-option-index="scope.index"
            >
              {{ scope.opt.label }}
            </q-item-label>
          </q-item-section>
          <q-tooltip
            v-if="truncatedOptions.includes(scope.index)"
            :delay="300"
          >
            {{ scope.opt.label }}
          </q-tooltip>
        </q-item>
      </template>

      <q-tooltip
        no-parent-event
        :value="fieldTooltip"
        :delay="300"
      >
        {{ selectedLabel }}
      </q-tooltip>
    </q-select>
  </div>
</template>

<script>
import ArrowDownIcon from '@/assets/icons/arrowDown.svg'
import { mapGetters } from 'vuex'
import truncateTooltip from '@/mixins/truncateTooltip'

export default {
  components: {
    ArrowDownIcon
  },

  mixins: [truncateTooltip],

  props: {

    value: {}

  },

  data () {
    return {
      selectedValue: this.value,
      filteredOptions: this.list,
      disabled: false,
      loading: true
    }
  },
  computed: {
    ...mapGetters({
      sessionMembership: 'agentModule/sessionMembership'
    }),

    selectedLabel () {
      return this.filteredOptions?.find(({ id }) => id === this.selectedValue)?.label ?? ''
    }
  },

  mounted () {
    const queueList = this.sessionMembership

    if (!queueList.length) {
      this.loading = true
      return
    }

    if (queueList) {
      this.filteredOptions = queueList.filter((item) => !item.queueId.startsWith('iqda')).map((item) => {
        return { id: item.queueId, label: item.queueName }
      })
    }
    this.loading = false
  },

  watch: {
    selectedValue (selectedValue) {
      if (selectedValue === this.value) return
      this.$router.push({ name: 'ROUTE_PREVIEW_DETAILS', params: { queueId: selectedValue } })
      this.$emit('input', selectedValue)
    },

    value (value) {
      if (value === this.selectedValue) return
      this.selectedValue = value
    },

    '$route.name': {
      handler (routeName) {
        if (routeName === 'ROUTE_PREVIEW_DETAILS') {
          this.disabled = false
        }

        if (routeName === 'ROUTE_PREVIEW_CURRENT') {
          this.disabled = true
        }
      },

      immediate: true

    },

    sessionMembership: {
      handler (queues) {
        this.filteredOptions = queues.filter((item) => !item.queueId.startsWith('iqda')).map((item) => {
          return { id: item.queueId, label: item.queueName }
        })
        this.loading = false
      }

    },
    deep: true,
    immediate: true
  }
}

</script>

<style lang="sass">
.queue-select-root
  contain: inline-size
  min-width: 0
  max-width: 100%

.field-select-popup
  max-width: min(480px, calc(100vw - 32px))

.queueSelect
  max-width: 100%
  .q-field__control
    min-height: 20px
    min-width: min(250px, 100%)

    .q-field__control-container
      min-width: 0

    .q-field__native
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis

    .q-field__control-container
      font-size: 14px

    &:hover
      &:before
        border: 1px solid #486e8e !important
        transition: none

    &:after
      border-width: 1px !important

</style>
